import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updateSalesTargetApi = createAsyncThunk("updateSalesTarget", async (formData) => {
    const response = await axiosInstance.put(`/salesTarget/update/${formData._id}`, formData);
    return response.data;
});

const updateSalesTargetSlice = createSlice({
    name: "updateSalesTarget",
    initialState: {
        updateSalesTarget: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateSalesTargetApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSalesTargetApi.fulfilled, (state, action) => {
                state.updateSalesTarget = action.payload;
                state.loading = false;
            })
            .addCase(updateSalesTargetApi.rejected, (state, action) => {
                state.errors = action.payload || action.error.message;
                state.loading = false;
            });
    },
});

export default updateSalesTargetSlice.reducer;
